import { useMemo } from 'react';

import {
  AlertCircleIcon,
  Cancel01Icon,
  CancelCircleIcon,
  CheckmarkCircle03Icon,
  InformationCircleIcon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import { toast } from 'react-hot-toast';
import { Link } from 'react-router-dom';

import { IconComponent } from 'components/Icon/IconComponent';

import styles from './CustomToast.module.scss';

export const CustomToast = ({
  t,
  message = '',
  title = '',
  type = 'info',
  icon,
  linkTo = null,
  linkText = 'View all',
  actionLabel = null,
  onAction = null,
}) => {
  const setIcon = useMemo(() => {
    switch (type) {
      case 'success':
        return CheckmarkCircle03Icon;
      case 'error':
        return CancelCircleIcon;
      case 'warning':
        return AlertCircleIcon;
      case 'info':
        return InformationCircleIcon;
    }
  }, [type]);
  return (
    <div
      data-testid={`toast-${type}`}
      className={cn(
        styles.toast,
        styles[type],
        'd-flex u-padding u-gap-medium u-border-radius--medium u-drop-shadow--large',
        message ? 'align-items-start' : 'align-items-center',
      )}>
      <div className={styles.icon}>
        <IconComponent
          icon={icon || setIcon}
          noBackground
          type="neutral-dark"
          size="medium"
          strokeWidth={1.5}
        />
      </div>
      <div className={cn(styles.content, 'd-flex flex-column flex-grow-1')}>
        <span className="u-font-weight-400 u-font-size-medium white-text">{title}</span>
        <span className="u-font-weight-300 u-font-size-x-small white-text">{message}</span>
        {linkTo && (
          <Link
            to={linkTo}
            className={cn(styles.link, 'u-font-weight-300 u-font-size-x-small u-margin-top--small')}
            onClick={() => toast.dismiss(t.id)}>
            {linkText}
          </Link>
        )}
        {actionLabel && onAction && (
          <button
            type="button"
            className="mt-2 cursor-pointer border-0 bg-transparent p-0 text-left font-inherit text-xl font-light text-primary-2 underline hover:text-neutral-2"
            onClick={() => {
              onAction();
              toast.dismiss(t.id);
            }}>
            {actionLabel}
          </button>
        )}
      </div>
      <HugeiconsIcon
        data-testid="toast-dismiss-icon"
        size={20}
        icon={Cancel01Icon}
        strokeWidth={1.5}
        onClick={() => toast.dismiss(t.id)}
        className="u-pointer"
        color="#FFF"
      />
    </div>
  );
};
